import React from 'react';
import { FilterFlyoutButton } from '../FilterFlyoutButton';
import { FilterFlyoutContent } from '../FilterFlyoutContent';
import { useBreakpoints } from '@amzn/atoz-web/Responsive';
import { FlyoutWrapper } from '../../shared';
export var FilterFlyoutSelector = function (_a) {
    var children = _a.children, onFilterReset = _a.onFilterReset, onFilterOpen = _a.onFilterOpen, filterCount = _a.filterCount;
    var matches = useBreakpoints().matches;
    // if the viewport is too small, then just show the shift filters,
    // otherwise just show the ShiftFilters
    if (matches.s || matches.m) {
        return (React.createElement(FlyoutWrapper, { renderButton: FilterFlyoutButton(onFilterOpen, filterCount), renderContent: FilterFlyoutContent(children, onFilterReset) }));
    }
    return React.createElement(React.Fragment, null, children);
};
